import { Card, Divider, Pagination } from 'antd';
import { useEffect } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import SearchFilter from '../../component/Filter';
import NativeNumber from '../../component/Numeral';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import {
	getBlockchainNetworks,
	getCurrencies,
} from '../../methods/redux/reducers/currency';
import { getGlobalEnumsData } from '../../methods/redux/reducers/general';
import { getTransactionsReport } from '../../methods/redux/reducers/transactions';
import { getUserProfileById } from '../../methods/redux/reducers/user-profile';
import { transactionStatementTypes } from '../../methods/utils/general-utils';
import remakeQueryString from '../../methods/utils/remake-query-string';
import Aggregate from './Aggregate';
import ColumnItem from './ColumnItem';

export const UsersListPage = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	gap: 1em;

	& .myCard {
		border-radius: 10px;
		gap: 1em;
	}
`;
export const MainSection = styled(Card)`
	border-radius: 10px;
	gap: 2em;
`;

const TransactionStatement = () => {
	const dispatch = useAppDispatch();
	const { userId } = useParams();

	const [searchParams, setSearchParams] = useSearchParams();
	const { user } = useAppSelector((store) => store.userProfile);
	const { report } = useAppSelector((store) => store.transactions);
	const { currencies } = useAppSelector((store) => store.currencies);
	const { globalEnums } = useAppSelector((store) => store.general);

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
				perPage: String(report.paginator.perPage),
			});
		}

		if (userId) {
			dispatch(getUserProfileById(userId));
		}

		dispatch(getCurrencies({}));
		dispatch(getBlockchainNetworks());
		dispatch(getGlobalEnumsData());
	}, []);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			if (userId) {
				dispatch(getTransactionsReport({ ...queryData, userId }));
			} else {
				dispatch(getTransactionsReport(queryData));
			}
		}
	}, [searchParams]);

	const currencySelect = currencies.map((item: any) => ({
		name: item.symbol,
		value: item._id,
	}));

	return (
		<Card>
			<h1>
				Transactions Report{' '}
				{userId && (
					<span>
						{' '}
						for{' '}
						<Link
							title="View Profile"
							to={`/user-profile/${user.profile?._id}`}
						>
							@{user.profile?.username}
						</Link>
					</span>
				)}
			</h1>
			<p>
				Use the filter options to get transactions and transaction volume for
				transactions of different forms like fixed savings, flexible etc.
			</p>

			<Aggregate data={report.result} />

			{/* {!userId && <TransactionFilter />} */}

			<br />

			<SearchFilter
				title="Search Transactions Report"
				searchFilters={[
					{
						label: 'Start Date',
						name: 'startDate',
						htmlElement: 'datepicker',
					},
					{
						label: 'End Date',
						name: 'endDate',
						htmlElement: 'datepicker',
					},
					{
						label: 'Currency',
						name: 'currencyId',
						htmlElement: 'select',
						selectOptions: currencySelect,
					},
					{
						label: 'Transaction Form',
						name: 'form',
						htmlElement: 'select',
						selectOptions: transactionStatementTypes(
							globalEnums.TRANSACTION_STATEMENT_FORM
						),
					},
					{
						label: 'Type',
						name: 'type',
						htmlElement: 'select',
						selectOptions: [
							{ name: 'Credit', value: 'credit' },
							{ name: 'Debit', value: 'debit' },
							{ name: 'Unknown', value: 'unknown' },
						],
					},
				]}
				retrieveQueryString={updateQueryString}
			/>

			<br />

			<p>
				Total of{' '}
				<strong>
					<NativeNumber value={report.paginator.itemCount} /> items
				</strong>{' '}
				found
			</p>

			<br />

			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={report.paginator.itemCount}
				current={report.paginator.currentPage}
				pageSize={report.paginator.perPage}
			/>
			<br />

			{report.itemsList.map((item: any) => (
				<ColumnItem key={item?._id} data={item} />
			))}

			<Divider />

			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={report.paginator.itemCount}
				current={report.paginator.currentPage}
				pageSize={report.paginator.perPage}
				showSizeChanger
				showQuickJumper
			/>
		</Card>
	);
};

export default TransactionStatement;
